import http from "../../app/utils/http";

export const CUSTOMER_URL = "user_customers";


export const getCustomers = () => http.get(`${CUSTOMER_URL}`);
export const getProviders = () => http.get(`user_providers`);

